
import { Component, Prop, Vue } from 'vue-property-decorator';

// Interfaces
import User from '@/ship/Models/User';
import UserService from '@/utils/UserService';

@Component
export default class VUserAvatar extends Vue {
    @Prop({ type: Object, default: null })
    public user!: User | null;

    public isImageLoadFailed = false;

    get abbreviation() {
        return UserService.getUserAbbreviation(this.user);
    }

    get avatar() {
        return this.user?.socialAvatar.avatar;
    }

    get hslGradus() {
        return this.user?.socialAvatar.hslGradus;
    }

    get avatarBackgroundStyles() {
        return {
            'background-color': this.hslGradus && `hsl(${this.hslGradus}, 68%, 77%)`,
        };
    }

    public handleImageLoadError() {
        this.isImageLoadFailed = true;
    }
}
